import { atom, createStore } from 'jotai';
import { utcMoment } from '../utils';
import { IAccountDetail } from '@components/usage-dashboard/atoms/typed';
import { PRODUCT_MODE_MAP } from '@src/utils/constants';
import { GRANULARITY } from '@src/utils/granularity';

// product key is being used to identify the dataset. which is used to query metric gateway
export const usageMetricList: any = {
  IntervalMinutesPlayedWithAds: {
    product: PRODUCT_MODE_MAP.EI,
    metricName: 'IntervalMinutesPlayedWithAds',
    displayName: 'Total Viewer Hrs',
    tooltipText:
      'Viewers Hours (Playing Time Interval): Content + Server Side Ads Hrs + Client Side Ads Hrs',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across non-traffic routing C3 accounts',
  },
  ConcurrentPlays: {
    product: PRODUCT_MODE_MAP.EI,
    metricName: 'ConcurrentPlays',
    displayName: 'Video Concurrent Plays',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across non-traffic routing C3 accounts',
  },
  AppTotalEvents: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'AppTotalEvents',
    displayName: 'Total Events',
    localUnit: '',
    c3AccountsSumTooltip:
      'Sum across all C3 accounts (may change once we support routing accounts in Eco)',
  },
  AppSessions: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'eco_app_sessions',
    displayName: 'User Sessions (Ended)',
    localUnit: '',
    c3AccountsSumTooltip:
      'Sum across all C3 accounts (may change once we support routing accounts in Eco)',
  },
  ecoTotalFlows: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'eco_total_flows',
    displayName: 'Total Flows',
    localUnit: '',
    c3AccountsSumTooltip: 'Per C3 account usage (choose maximum of the selected C3 accounts)',
  },
  ecoTotalMetrics: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'eco_total_metrics',
    displayName: 'Total Metrics',
    localUnit: '',
    c3AccountsSumTooltip: 'Per C3 account usage (choose maximum of the selected C3 accounts)',
  },
  // UserActiveTime: {
  //   product: PRODUCT_MODE_MAP.APP,
  //   metricName: 'UserActiveTime',
  //   displayName: 'User Active Hrs',
  //   localUnit: '',
  // },

  ecoPeakEventRate: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'eco_peak_event_rate',
    displayName: 'Peak Events per Minute',
    localUnit: '',
    c3AccountsSumTooltip:
      'Sum across all C3 accounts (may change once we support routing accounts in Eco)',
  },

  ecoAppEventsPerSession: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'eco_avg_events_per_user_session',
    displayName: 'Average Events Per Session',
    localUnit: '',
    c3AccountsSumTooltip: 'Average across all C3 accounts',
  },
  RealtimeAPICalls: {
    product: 'API',
    metricName: 'RealtimeAPICalls',
    displayName: 'Realtime API calls',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
  HistoricalAPICalls: {
    product: 'API',
    metricName: 'HistoricalAPICalls',
    displayName: 'Analytics API calls',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
};

export const usageTableMetricList = {
  ...usageMetricList,
  ecoTotalDimensions: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'ecoTotalDimensions',
    displayName: 'Total Dimensions',
    localUnit: '',
    c3AccountsSumTooltip: 'Per C3 account usage (choose maximum of the selected C3 accounts)',
  },
  ecoCustomDimensions: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'ecoCustomDimensions',
    displayName: 'Custom Dimensions',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
  ecoCustomMetrics: {
    product: PRODUCT_MODE_MAP.APP,
    metricName: 'ecoCustomMetrics',
    displayName: 'Custom Metrics',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
  videoTotalDimensions: {
    product: PRODUCT_MODE_MAP.EI,
    metricName: 'videoTotalDimensions',
    displayName: 'Total Dimensions',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
  videoCustomDimensions: {
    product: PRODUCT_MODE_MAP.EI,
    metricName: 'videoCustomDimensions',
    displayName: 'Custom Dimensions',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
  videoSsdDaily: {
    product: PRODUCT_MODE_MAP.EI,
    metricName: 'videoSsdDaily',
    displayName: 'SSD Daily',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
  videoSsdHourly: {
    product: PRODUCT_MODE_MAP.EI,
    metricName: 'videoSsdHourly',
    displayName: 'SSD Hourly',
    localUnit: '',
    c3AccountsSumTooltip: 'Sum across all C3 accounts',
  },
};

const intervalAtom = atom<any>(null);
const granularityAtom = atom(GRANULARITY.P1D);
const videoAccountsDetailsAtom = atom<IAccountDetail[]>([]);
const appAccountsDetailsAtom = atom<IAccountDetail[]>([]);
const apiAccountsDetailsAtom = atom(<IAccountDetail[]>[]);
const tableViewSwitchAtom = atom<boolean>(false);

function initStore() {
  const store = createStore();
  const lastMonthInterval: any = [
    utcMoment().subtract(1, 'month').startOf('month'),
    utcMoment().subtract(1, 'month').endOf('month'),
  ];
  store.set(intervalAtom, lastMonthInterval);
  return store;
}

export {
  intervalAtom,
  granularityAtom,
  videoAccountsDetailsAtom,
  appAccountsDetailsAtom,
  apiAccountsDetailsAtom,
  tableViewSwitchAtom,
  initStore,
};
